import { ISetup } from "@smartrr/shared/entities/Organization";
import { GettingStartedStepInterface } from "./interface";

/**
 * Each concrete step owns its own domain rule for what "completed" means,
 * derived from the shop's setup.
 */
export abstract class GettingStartedStep implements GettingStartedStepInterface {
  private readonly completed: boolean;

  constructor(setup: ISetup) {
    this.completed = this.deriveCompleted(setup);
  }

  abstract getOrder(): number;

  isCompleted(): boolean {
    return this.completed;
  }

  protected abstract deriveCompleted(setup: ISetup): boolean;
}
